import React from 'react'
import {Col, Form, FormGroup, Label, Row} from "reactstrap";
import FieldWithValidation from "../../generic/fields/FieldWithValidation";
import {Controller} from "react-hook-form";
import i18n, {t} from "i18next";
import Select from "react-select";
import {TYPE_EXPENSES_VISIBILITY_LANG_ADAPTER} from "sv-common/constants/typeExpensesVisibility";


const getTypeExpensesVisibilityMultiselect = (language) => ([
    ...Object.keys(TYPE_EXPENSES_VISIBILITY_LANG_ADAPTER[language]).map(typeExpensesVisibility => ({label: TYPE_EXPENSES_VISIBILITY_LANG_ADAPTER[language][typeExpensesVisibility], value: typeExpensesVisibility}))
])

const EditModalChildren = ({entity, setEntity, control, errors, handleInput}) => {
    const {language} = i18n;
    const typeExpensesVisibilityMultiselect = getTypeExpensesVisibilityMultiselect(language);

    const setTypeExpensesVisibility = typesExpensesVisibility => {
        setEntity({
            ...entity,
            visibility: (typesExpensesVisibility || []).map(typeExpensesVisibility => typeExpensesVisibility.value)
        })
    }

    return <Form>
        <Row>
            <Col lg={6}>
                <FormGroup>
                    <Controller
                        control={control}
                        name="name"
                        defaultValue={entity.name || ''}
                        rules={{required: t('inputs.validation.required')}}
                        render={(
                            {value, onBlur, name, ref, onChange},
                            {invalid}
                        ) =>
                            <FieldWithValidation invalid={invalid} errors={errors} name={name} isRequired={true}
                                                 type="text" onBlur={onBlur} value={value}
                                                 label={t('directories.typeExpenses.name')}
                                                 placeholder={t('directories.typeExpenses.name')}
                                                 onChange={e => {onChange(handleInput(e, setEntity).value)}}
                            />
                        }
                    />
                </FormGroup>
            </Col>
            <Col lg={6}>
                <FormGroup>
                    <Controller
                        control={control}
                        name="key"
                        defaultValue={entity.key}
                        render={(
                            {value, onBlur, name}
                        ) =>
                            <FieldWithValidation errors={errors} name={name}
                                                 label={t('directories.typeExpenses.key')} disabled
                                                 type="text" onBlur={onBlur} value={value}
                                                 placeholder={t('directories.typeExpenses.key')}
                                                 info={t('directories.typeExpenses.infoIcon.keyInputInfo')}
                                                 container={'.modal'}
                            />
                        }
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col lg={6}>
                <FormGroup>
                    <Label>{t('directories.typeExpenses.visibility')}</Label>
                    <Select
                        name="visibility" isMulti options={typeExpensesVisibilityMultiselect}
                        onChange={setTypeExpensesVisibility} menuPlacement={'top'}
                        value={(entity.visibility || []).map(val => typeExpensesVisibilityMultiselect
                            .filter(option => option.value === val)[0])}
                    />
                </FormGroup>
            </Col>
        </Row>
    </Form>
}

export default EditModalChildren;
